import React from "react";
import * as ReactFeather from "react-feather";
import PropTypes from "prop-types";
import { noop } from "./easyConst";

function Tabs({ childTabs, tabsetName, onTabChange, children }) {
  const onChange = onTabChange ? (e) => onTabChange(e.target.id) : noop;
  return (
    <div className="tabset ">
      {childTabs.map((eachTab, i) => {
        let eachTabIcon = eachTab["icon"];
        let Icon = ReactFeather[eachTabIcon];
        let labelStyle = eachTab["disabled"]
          ? {
            textTransform: "capitalize",
            color: "#475668",
            border: "0px #d8d8d8",
            cursor: "not-allowed",
            pointerEvents: "none",
            opacity: "0.2",
          }
          : { textTransform: "capitalize" };
        return (
          <React.Fragment key={i}>
            {/* { eachTabIcon && <Icon /> } */}
            <input type="radio" {...eachTab} name={tabsetName} onChange={onChange} />
            <label style={labelStyle} htmlFor={eachTab.id}>
              {eachTabIcon && <Icon />}
              <span dangerouslySetInnerHTML={{ __html: eachTab.name }}></span>
            </label>
          </React.Fragment>
        );
      })}
      <div className="tab-panels">{children}</div>
    </div>
  );
}
Tabs.propTypes = PropTypes.shape({
  childTabs: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      id: PropTypes.string,
      defaultChecked: PropTypes.bool,
      disabled: PropTypes.bool,
    })
  ),
  tabsetName: PropTypes.string,
  onTabChange: PropTypes.func,
});
/*        
  children:
    <Tabs {...PropsToPass}>
      <TabsPane id="myProfile" className="optional-classname" >
            // Tab Element
      </TabsPane>
    </Tabs>              
*/

export default Tabs;



// WEBPACK FOOTER //
// ./src/components/bewise/Tabs/index.js